import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ProductoFacturado } from 'src/app/models/producto-trazabilidad.interface';
import { TrazabilidadProducto } from 'src/app/models/trazabilidad-producto.interface';
import { EmpresaService } from 'src/app/services/empresa.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-trazabilidad-form',
  templateUrl: './trazabilidad-form.component.html',
  styleUrls: ['./trazabilidad-form.component.scss'],
  providers: [MessageService]
})
export class TrazabilidadFormComponent {
  // id_producto_facturado: number;
  visible: boolean = false;
  productoForm!: FormGroup;
  producto!: ProductoFacturado;

  constructor(private fb: FormBuilder, private auth: AuthService, private empresaService: EmpresaService, private rutaActiva: ActivatedRoute, private router: Router, private messageService: MessageService) {
    let producto_id: number = this.rutaActiva.snapshot.params['id'];
    this.load(producto_id);
  }
  load(id: number): void {
    this.empresaService
      .productoFacturado(id)
      .subscribe({
        next: (resp) => {
          this.producto = resp.datos;
          this.productoForm = this.crearProducto(this.producto.id, this.producto.fk_tipo_producto);
        }, error: (err) => { console.error(err.error.message) }
      })
  }
  crearProducto(productofacturado_id: number, tipo_producto_id: number): FormGroup {
    return this.fb.group({
      fk_producto_facturado: [productofacturado_id, Validators.required],
      fk_tipo_producto: [tipo_producto_id, Validators.required],
      lote: ['', Validators.required],
      fecha_aplicacion_producto: [null, [Validators.required]],
      nom_hospital: ['', [Validators.required]],
      nom_medico: [''],
      nom_paciente: [''],
      entidad_federativa: ['', [Validators.required]],
      manifiesto: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    });
  }
  /** Atajo para acceder a un control en la plantilla */
  getControl(name: string): AbstractControl {
    return this.productoForm.get(name)!;
  }
  onSubmit() {
    console.log(this.productoForm.getRawValue())
    let row: TrazabilidadProducto = this.productoForm.getRawValue();
    row.manifiesto = this.productoForm.get('manifiesto')?.value ? 1 : 0;

    if (this.productoForm.invalid) {
      this.productoForm.markAllAsTouched();
      return;
    }
    if (this.producto.trazabilidad_productos.length < this.producto.cantidad_productos) {
      this.empresaService.trazabilidadProducto(row).subscribe({
        next: (resp) => { this.showSuccess(resp.mensaje); this.agregar(this.productoForm.getRawValue()); this.visible = false; this.productoForm.reset(); },
        error: (err) => { console.error(err.error.message) }
      })

    }
    else this.showWarning('Completado')
  }


  agregar(arg: {
    fk_producto_facturado: number;
    fk_tipo_producto: number;
    lote: string;
    fecha_aplicacion_producto: Date;
    nom_hospital: string;
    entidad_federativa: string;
    nom_medico: string;
    nom_paciente: string;
    manifiesto: number;
  }): void {

    let traza: TrazabilidadProducto = {
      fk_producto_facturado: arg.fk_producto_facturado,
      fk_tipo_producto: arg.fk_tipo_producto,
      lote: arg.lote,
      fecha_aplicacion_producto: arg.fecha_aplicacion_producto,
      nom_hospital: arg.nom_hospital,
      entidad_federativa: arg.entidad_federativa,
      nom_medico: arg.nom_medico,
      nom_paciente: arg.nom_paciente,
      manifiesto: arg.manifiesto ? 1 : 0,
      tipo_producto: this.producto.tipo_producto,
    };
    if (this.producto.trazabilidad_productos.length < this.producto.cantidad_productos)
      this.producto.trazabilidad_productos.push(traza);
    else
      this.showWarning('Completado')

  }
  showDialog() {
    if (this.producto.trazabilidad_productos.length < this.producto.cantidad_productos) {
      this.productoForm.get('fk_producto_facturado')?.setValue(this.producto.id);
      this.productoForm.get('fk_tipo_producto')?.setValue(this.producto.fk_tipo_producto);
      this.productoForm.get('lote')?.setValue(this.producto.lote);
      this.visible = true;
    }
    else this.showWarning('Completado')

  }
  salir() {
    this.router.navigate(["/productos-facturados"]);
  }
  showSuccess(msg: string): void {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: msg });
  }
  showWarning(msg: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Nota!!', detail: msg });
  }
}
